module.exports = {
  "plan":[
    // {
    //   'id': '0',
    //   'name': '电柜除湿技术发展历程',
    //   'from':'盈能电气',
    //   'data':'2019-08-30'
    // },
  ],
  "detail":[
    // {
    //   'id':'0',
    //   'name':'电压感应取电技术在无源测温上的应用1',
    //   'article':'<p>\n' +
    //     '    湿气对电气设备的安全危害非常大，湿气不仅能够降低设备的绝缘水平，而且设备长时间浸润在湿气中，锈蚀等也直接损害设备的本体结构安全。由于湿气对电气设备的危害非常大，所以电柜除湿一起很受电力客户的重视。\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    <br/>\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    &nbsp; &nbsp; &nbsp;排水型除湿器面世前，电柜除湿主要采用加热除湿的技术方案。这也是基于我们通常的除湿常识。当温度升高时，湿气会蒸发，这样也就驱除了设备表面的湿气。加热除湿技术的应用，大大减少了电柜受潮对设备的危害。同时，一些新的加热技术也开始涌现。原来采用的加热器通常采用电阻丝作为加热源，这种加热源有升温快、成本低的优点，但由于加热源本身温度非常高，加热器运行时，加热器本体温度也会非常高，导致靠近加热源的电缆在长期高温下受损；另外，电阻丝也较易断裂。因此，有电力公司就将两台加热器串接在一起使用，使加热器的工作电压减少一半，从220V出降为110V，这样单台加热器功率降为设计功率的25%（0.5U*0.5U/R），两台加热器也只有原来设计功率的50%，但加热器表面温度大大降低，寿命也大大延长。\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    <br/>\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    &nbsp; &nbsp; &nbsp;针对电阻丝加热器的问题，以PTC陶瓷加热体作为加热源的加热器应运而生。PTC陶瓷可以定制一个工作温度，其本身具有的抑温性能，在加热体升温过高时，会自动停止加热，使加热器维持一个稳定的温度。由于PTC陶瓷加热器的这个优点，受到了客户的欢迎。在2000年左右有某外资电气公司引入中国时，单台售价高达3000元人民币 。不过，国产后，售价迅速跌落，目前一般单台也不会超过50元，不足原来售价的2%。但也由于PTC陶瓷的抑温性，PTC陶瓷发热体的功率一般都较小，很少能够做到100W以上，即使多个PTC陶瓷发热体并接在一起，实测的功率仍然很难达到设计要求。一般卫生间浴霸、热风机，主要也是采用PTC陶瓷发热体作为加热元件，但这些设备功率之所以能够做到1000W、2000W，主要是在PTC陶瓷发热体后部增加了风扇，使积聚在PTC陶瓷发热体上的热量迅速分散，不产生抑温性，从而使设备功率得到充分发挥。\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    <br/>\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    &nbsp; &nbsp; &nbsp;在PTC陶瓷加热器面世不久，橡胶加热器也开始上市。它采用类似电热毯的原理，在一个绝缘板上铺设电阻丝，然后在表面覆盖橡胶作为绝缘。由于制造过程非常精准，橡胶加热器质量比较好，而且由于表面覆盖橡胶，温度也非常均衡，而且厚度超薄，一般厚度不超过5mm，在一些小空间使用非常合适。\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    <br/>\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    &nbsp; &nbsp; &nbsp;除了加热器内的加热源变化，对于柜内湿度的控制也从手动变成了自动。这样，湿度大了，加热器自动启动，湿度小了，加热器自动关闭。针对电柜内部空气相对密封，不流通，会影响除湿效果，所以，有些湿度自动控制器增加了风扇接点，当除湿时，风扇自动启动，保持电柜内空气一定流通。\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    <br/>\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    &nbsp; &nbsp; &nbsp;随着加热器的普遍应用，电力客户发现，很多安装了加热器的电柜，柜内湿度仍然非常大。对此进一步研究分析后发现，由于加热时，湿气虽然有蒸发，但湿气还在柜内。由于湿气凝露，本来就是由于温差变化原因导致湿气遇冷凝结，当环境温度降温较大时，加热器受功率局限，无法消除降温的影响，湿气就仍然因降温而凝结成水。因此，加热器从原理上，无法根本解决湿气凝露问题。\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    <br/>\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    &nbsp; &nbsp; &nbsp;2010年，常州市盈能电气有限公司推出了新型除湿器，这种除湿器没有采用加热蒸发技术，而是利用湿气遇冷会凝水的特点，在除湿器内部特意设计了一台电子冷凝器，使湿气在电子冷凝器上凝结，然后收集排出柜外，为了提高除湿效率，电子冷凝器侧设计了一台薄型风扇，促进空气循环。这种除湿器，盈能电气命名为：排水型电柜除湿器。排水型电柜除湿器将电柜内的湿气冷凝排出后，电柜内部就没有湿气，不会再有湿气困扰。排水型电柜除湿器一经面世，就受到了客户欢迎。\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    <br/>\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    &nbsp; &nbsp; &nbsp;排水型电柜除湿器不会是电柜除湿的终极，在长时间应用后，我们还能发现这种技术的不足，这时，又是一次推动除湿技术发展的机会。\n' +
    //     '</p>\n' +
    //     '<p>\n' +
    //     '    <br/>\n' +
    //     '</p>'
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/data/plan.js